import { useEffect, useRef } from 'react';

export const usePrevious = value => {
  const ref = useRef();
  useEffect(
    () => {
      ref.current = value;
    },
    [value]
  ); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
};
